import { Injectable } from '@angular/core';
import { ID_LOG_ROCKET, ID_RUT_REGEX } from '@common/constants/log-rocket.constants';
import { environment } from '@env';
import * as LogRocket from 'logrocket';


@Injectable({
  providedIn: 'root'
})
export class LogrocketService {

  constructor() { }

  public initializeLogRocketRUM(id: string, name: string = environment.ENV) {

    if (id && id.trim() !== '') {
      const sanitizedId = id.replace(ID_RUT_REGEX, "").trim();

      if (sanitizedId !== '') {
        LogRocket.startNewSession();
        LogRocket.init(ID_LOG_ROCKET, {
          network: {
            requestSanitizer: request => {
              return this.ofuscarBody(request);
            },
          },
        });

        LogRocket.identify(sanitizedId);
      }
    }

  }
  public setLogRocketIdentify(id: string, userName?) {
    if (userName) {
      LogRocket.identify(id, {
        name: String(userName)
      })
    } else {
      LogRocket.identify(id)
    }
  }

  private ofuscarBody(request): any {
    if (request.url.toLowerCase().indexOf('early-withdrawal/login') !== -1) {
      request.body = this.ofuscarBodyPorCampo(request.body, "affiliateSerialNumber")
      request.body = this.ofuscarBodyPorCampo(request.body, "mandatarySerialNumber")
    }

    return request;
  }

  private ofuscarBodyPorCampo(body: string, field: string): string {
    if (body.indexOf(field) !== -1)
      return body.replace(body.substring(body.indexOf(field) + `'${field}':`.length, body.length - 2), '');

    return body;
  }
}
